(function () {
  "use strict";

  var SUBMIT_KEYWORDS = ["valider", "commander", "confirmer", "passer la commande", "finaliser"];
  var RESET_TIMEOUT_MS = 15000;
  var submittedForms = new WeakSet();

  function textMatches(el) {
    if (!el) return false;
    var text = (el.innerText || el.value || "").trim().toLowerCase();
    if (!text) return false;
    for (var i = 0; i < SUBMIT_KEYWORDS.length; i++) {
      if (text.indexOf(SUBMIT_KEYWORDS[i]) !== -1) return true;
    }
    return false;
  }

  function findSubmitControl(form) {
    var candidates = form.querySelectorAll('button[type="submit"], input[type="submit"], button:not([type])');
    for (var i = 0; i < candidates.length; i++) {
      if (textMatches(candidates[i])) return candidates[i];
    }
    return candidates.length ? candidates[0] : null;
  }

  function lockControl(control) {
    if (!control) return;
    if (control.dataset.originalLabel === undefined) {
      control.dataset.originalLabel = control.tagName === "INPUT" ? control.value : control.innerHTML;
    }
    control.disabled = true;
    control.setAttribute("aria-disabled", "true");
    control.style.opacity = "0.6";
    control.style.cursor = "not-allowed";
    if (control.tagName === "INPUT") {
      control.value = "Traitement en cours...";
    } else {
      control.innerHTML = "Traitement en cours...";
    }
  }

  function unlockControl(control) {
    if (!control) return;
    control.disabled = false;
    control.removeAttribute("aria-disabled");
    control.style.opacity = "";
    control.style.cursor = "";
    if (control.dataset.originalLabel !== undefined) {
      if (control.tagName === "INPUT") {
        control.value = control.dataset.originalLabel;
      } else {
        control.innerHTML = control.dataset.originalLabel;
      }
    }
  }

  document.addEventListener(
    "submit",
    function (event) {
      var form = event.target;
      if (!form || form.tagName !== "FORM") return;

      var control = findSubmitControl(form);
      if (!control && !textMatches(document.activeElement)) return;
      if (!control) control = document.activeElement;
      if (!textMatches(control) && !textMatches(form)) {
        return;
      }

      if (submittedForms.has(form)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      submittedForms.add(form);
      lockControl(control);

      setTimeout(function () {
        submittedForms.delete(form);
        unlockControl(control);
      }, RESET_TIMEOUT_MS);
    },
    true
  );
})();
